import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { toast } from 'react-toastify'
import classNames from 'classnames'

import { toggleUserCommunityFeature } from '../../../actions/featureActions'
import { Link } from 'react-router-dom'
import Toggle from '../../common/form/Toggle'
import ClubsPreview from '../../../assets/images/op-36-clubs/clubs-preview.webp'

import classes from './GolfClubs.module.scss'

const GolfClubs = () => {
  const dispatch = useDispatch()

  const currentUser = useSelector(state => state.user.current_user)
  const community = currentUser.communities[0]

  const features = community.features || []
  const golfClubsFeature = features.find(feature => feature.key === 'golf_clubs') || { key: 'golf_clubs', enabled: false, name: 'Golf Clubs' }
  const [enabled, setEnabled] = useState(golfClubsFeature.enabled)

  const [loading, setLoading] = useState(false)

  const handleToggleChange = () => {
    setLoading(true)

    dispatch(toggleUserCommunityFeature(community.id, { key: golfClubsFeature.key, enabled: enabled }))
      .then(() => toast.success('Op 36 Clubs settings updated successfully!'))
      .catch(() => toast.error('Something went wrong. Please try again later.'))
      .finally(() => { setEnabled((prev) => !prev); setLoading(false) })
  }

  return (
    <div className={classes.GolfClubsTab}>
      <div className={classNames('py-4 px-3', classes.form)}>
        <h6 className={classNames('pb-4', classes.title)}>Op 36 Clubs - Powered by Henry-Griffitts</h6>

        <img className='w-100' src={ClubsPreview} alt='Op 36 Clubs Preview'/>

        <div className={classNames('py-3', classes.description)}>
          <section className='mb-3'>
            <span className='font-weight-bold'>Make sure your students always show up with clubs that are fit.</span>
            <br/>

            Too often beginners arrive with clubs that are too long, too heavy, or not made for them. That&apos;s why we partnered with
            Henry-Griffitts to create hand-crafted, properly fit clubs made just for Operation 36 beginners.
          </section>

          <section className='mb-3'>
            <span className='font-weight-bold'>Beginners can now:</span>

            <ul>
              <li>Start with one club at a time and add more as they level up</li>
              <li>Get custom fit to height and swing speed</li>
              <li>Choose adult or junior, left or right-handed</li>
              <li>Access affordable, high-quality gear that grows with them</li>
            </ul>
          </section>

          <section className='mb-3'>
            <span className='font-weight-bold'>How it works:</span>
            <br/>

            Turning this setting on allows you to offer Op 36 Clubs in your programs. You still have full control - you&apos;ll need to enable the
            &quot;Do you need clubs?&quot; option when setting up each program before families will see the choice to order at registration.
          </section>

          <p className='font-italic bt-2 mb-3'>
            If you prefer not to offer clubs, simply disable it - no prompts will appear and your community will not receive any direct marketing.
          </p>

          <Link
            className='font-weight-bold'
            to='https://intercom.help/op-36/en/articles/12507499-operation-36-clubs-everything-you-need-to-know'
            target='_blank'
            rel='noreferrer'
          >
            Learn more about integrating Op 36 Clubs into your program
          </Link>
        </div>

        <div className={classNames(classes.toggleWrapper, 'mt-2 d-flex align-items-center')}>
          <Toggle name='enabled' checked={enabled} disabled={loading} onChange={handleToggleChange}/>

          <label className={classNames(classes.checkboxLabel, 'ml-3')} htmlFor='enabled'>
            {enabled
              ? (
                <div>
                  <span className='font-weight-bold'>Enabled - </span>
                  Offer Op 36 Clubs to your students during registration.
                </div>
              )
              : (
                <div>
                  <span className='font-weight-bold'>Disabled - </span>
                  No prompts will appear and your community will not receive any direct marketing.
                </div>
              )
            }
          </label>
        </div>
      </div>
    </div>
  )
}

export default GolfClubs
